import { useState } from 'react';
import resend from "../../../assets/images/resend.png";
import {
  Modal
} from 'reactstrap';
import { Box, Typography, IconButton } from '@mui/material';
import MuiModal from "@mui/material/Modal";
import ClearIcon from "@mui/icons-material/Clear";

import message from "../../../assets/images/message.png";
import "./ResendContent.css";
import close from "../../../assets/images/close.png";
import OtpConsent from '../../Consent/OtpConsent/OtpConsent';

import 'react-bootstrap-switch/dist/css/bootstrap3/react-bootstrap-switch.min.css';
import axiosInstance from '../../../helpers/axios';
import { useCurrentUser } from '../../../hooks/useCurrentUser';

export default function ResendConsent(userInfo) {

  const [isModalOpen, setIsModalOpen] = useState(false);
  //const { user, logOut } = useUserAuth();
  const decode = useCurrentUser();
  const user = null;

  //Bijay Otp Consent
  const [open, setOpen] = useState(false);
  const [link, setLink] = useState("");
  const handleCloseConsent = () => setOpen(false);
  const [openOtpConsent, setOpenOtpConsent] = useState(false);

  
 

//resend consent
const [resendModal,setResendModal]=useState(false)
const urlResendConsent=`/end-user/submit/resend-consent`
const handleResendConsent=(item)=>{
  if(decode?.clientId==='98ffb18a-9fee-43a5-91a3-4b2b9d9ae361' || (userInfo?.userInfo?.channel === 8 || userInfo?.userInfo?.channel === 10)){  //Doctoral institute
    setIsModalOpen(false)
    // handleStartSession() 
    setOpenOtpConsent(!openOtpConsent);
    return
  }
  const data={
    userId:item.userInfo.userId,
    mobile:item.userInfo.mobile
  }
  axiosInstance.post(urlResendConsent,data,{
    headers:{
    }
  })
  .then((res)=>{
  alert(`Resend Consent ${res.data.message}`)
  setResendModal(!resendModal)})
  .catch((err)=>alert(err));
  
}


const handleStartSession = () => {
  const userData = userInfo?.userInfo
  const fullName = userData?.name?.split(" ")
  const firstName = fullName[0]
  const lastName = fullName[1]
  const randomGen = Date.now().toString(36) + Math.random().toString(36).substr(2);
  window.getBureauSession(
      process.env.REACT_APP_PUBLIC_CONSENT_KEY,
      randomGen,
      `${firstName} ${lastName}`,
      "",
      "",
      userData?.mobile
    )
    .then((res) => {
      setOpen(true);
      setLink(res);
    });
};

const handleLoadSession = async () => {
  try {
    const result = await window.startBureauSession();
    if (result) {
      switch (result.status) {
        case "SUCCESS":
          try {
            let authToken = null;

            // Fetch the authToken
            const authResponse = await axiosInstance.post(`/login/auth`, {
              memberId: "9072e019-e159-4bdc-812a-bb3f255f4af0",
            });

            authToken = authResponse?.data?.data;

            if (!authToken) {
              throw new Error("Authentication token not received");
            }

            const userId = userInfo?.userInfo?.userId
            if (userId) {
              const data2 = {
                userId,
                latitude: 0,
                longitude: 0,
                doneBy: "end-user",
              };

              // Second API call
              await axiosInstance.post("/end-user/submit/qec", data2, {
                headers: {
                  Authorization: `Bearer ${authToken}`,
                  "Content-Type": "application/json",
                },
              });
              alert("Application Moved to In Review");
              handleCloseConsent();
              setTimeout(() => {
                window.location.reload();
              }, 1000);
            }
          } catch (error) {
            console.error("Error during SUCCESS case:", error);
            alert(
              "An error occurred while processing your request. Please try again."
            );
            handleCloseConsent();
            setTimeout(() => {
              window.location.reload();
            }, 1000);
          }
          break;

        case "EXIT":
          alert("Retry Submit");
          handleCloseConsent();
          break;

        case "ERROR":
          alert("Error Please Try Later");
          handleCloseConsent();
          break;

        default:
          alert("Contact our team for assistance");
          break;
      }
    }
  } catch (error) {
    console.error("Unexpected error in handleLoadSession:", error);
    alert("An unexpected error occurred. Please try again later.");
  }
};

 const submitApplicationToInReview = async () => {
    try {
      let authToken = null;

      // Fetch the authToken
      const authResponse = await axiosInstance.post(`/login/auth`, {
        memberId: "9072e019-e159-4bdc-812a-bb3f255f4af0",
      });

      authToken = authResponse?.data?.data;

      if (!authToken) {
        throw new Error("Authentication token not received");
      }

      const userId = userInfo?.userInfo?.userId
      if (userId) {
        const data2 = {
          userId,
          latitude: 0,
          longitude: 0,
          doneBy: "end-user",
        };

        // Second API call
        await axiosInstance.post("/end-user/submit/qec", data2, {
          headers: {
            Authorization: `Bearer ${authToken}`,
            "Content-Type": "application/json",
          },
        });
        alert("Application Moved to In Review");
        handleConsent();
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      }
    } catch (error) {
      console.error("Error during SUCCESS case:", error);
      alert(
        "An error occurred while processing your request. Please try again."
      );
      handleConsent();
      setTimeout(() => {
        window.location.reload();
      }, 1000);
    }    
  }
    
  


 const  handleConsent = () => {
    setOpenOtpConsent(!openOtpConsent);
  }

  
  return (
    <>
      <div>
      <img onClick={()=>setIsModalOpen(true)} style={{cursor:'pointer',width:'1.1vw'}} src={resend} alt="resend consent"/>
     
      {isModalOpen && (
         <>
        <div
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
          zIndex: 999,
        }}
      ></div>
     <Modal
     style={{
      
      height:'200px',
      top: '30%',
      
       
     
      
    }} className='resend' isOpen={isModalOpen}>
      
     <img style={{marginLeft:"28em",height:'18px',width:'18px',marginTop:'10px',cursor:"pointer"}} alt="" onClick={()=>setIsModalOpen(!isModalOpen)} src={close}/>
              <div style={{marginLeft:'4em'}}><img className="image" src={message} alt="message" /></div>
            <div style={{paddingLeft:'1.5em'}}>
              <p style={{}}>On Clicking <strong> Resend Consent </strong> an SMS will be sent to the <span style={{color:'black',textDecoration:"underline",paddingLeft:'5em'}}>Applicant registered mobile number</span> <strong>{userInfo.phone}</strong></p>
              </div>
           
              <div style={{display:'flex',alignItems:'center',justifyContent:'center',padding:'1em'}} >
              <button style={{width:"150px",backgroundColor:"#D32028",color:"white",border:"none",height:'30px',borderRadius:"5px", display: 'flex', justifyContent: 'center', alignItems: 'center' }} onClick={()=>handleResendConsent(userInfo)} type="button">Resend Consent</button>
              </div>
          </Modal>
          </>
          )}
      
    </div>

     <OtpConsent openOtpConsent={openOtpConsent} submitApplicationToInReview={submitApplicationToInReview} handleConsent={handleConsent} mobile={userInfo?.userInfo?.mobile}/>

    {/* Bijay OtpConsent Model     */}
    <MuiModal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={open}
        keepMounted
        closeAfterTransition
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            minHeight: "100vh",
          }}
        >
          <Box
            style={{ backgroundColor: "white" }}
            sx={{
              width: "500px",
              maxWidth: "90vw",
              borderRadius: "8px",
              boxShadow: 24,
              p: 2,
            }}
          >
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                mb: 2,
              }}
            >
              <Typography
                id="modal-modal-title"
                variant="h6"
                component="h2"
                sx={{
                  fontWeight: "500",
                  fontSize: "20px",
                }}
              >
                OTP Consent
              </Typography>
              <IconButton
                sx={{
                  border: "2px solid #DbDbDb",
                }}
                aria-label="close"
                size="small"
                onClick={handleCloseConsent}
              >
                <ClearIcon />
              </IconButton>
            </Box>

            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <iframe
                width="100%"
                height="630px"
                src={link}
                onLoad={handleLoadSession}
                title="bureau"
                style={{
                  border: "none",
                  borderRadius: "4px",
                }}
              ></iframe>
            </Box>
          </Box>
        </Box>
      </MuiModal>
    </>

  );
}

